// extracted by mini-css-extract-plugin
export default {"skillsContainer":"match_activity_skills-module___skillsContainer___ea5ccad3"};